export default {
  sections: {
    state: {
      title: 'Stare',
      fields: {
        pickup_visible: {
          label: 'Ridicare vizibilă',
        },
        has_pickup: {
          label: 'Ridicare',
        },
      },
    },
    scheduled_orders: {
      title: 'Comenzi programate',
      fields: {
        has_scheduled_orders: {
          label: 'Permiteți clienților să comande în avans pentru ore specifice?',
        },
        min_schedule_ahead_time_pickup: {
          label: 'Timp minim (minute) în avans pentru programarea comenzilor de <strong>ridicare</strong>',
          placeholder: '30',
        },
        last_order_gap_pickup: {
          label: 'Ultima oră posibilă de comandă pentru <strong>ridicare</strong> (minute înainte de închidere)',
          option: '{{value}} min',
        },
      },
    },
    preparation_time_pickup_orders: {
      title: 'Timp de preparare pentru comenzi de ridicare',
      fields: {
        average_order_preparation_time_min: {
          label: 'Timp de preparare în minute',
          placeholder: '20',
        },
        average_order_preparation_time_max: {
          label: 'până la',
          placeholder: 'Opțional',
        },
      },
    },
  },
  buttons: {
    save: 'Salvează',
  },
  toasts: {
    at_least_one_order_method_required:
      'Cel puțin 1 metodă de comandă (programată sau imediată) trebuie să fie activată. Nu le puteți dezactiva pe ambele.',
  },
};
